import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Icon from "@mdi/react";
import { mdiClose, mdiPencil } from "@mdi/js";
import moment from "moment";

import { pushNotification } from "utils/notifications";
import { getUserLogin } from "utils/utils";
import { getListDanhSachDonDatHang } from "../../../../../actions/DanhSachDonDatHang";
import DatHangApi from "service/DatHang/DatHangApi";

export const ModalSua = ({ CloseModalSua, item }) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchDanhSachDonDatHang);

  const [loading, setLoading] = useState(false);
  const [doubleClick, setDoubleClick] = useState(false);
  const [dataBanHang, setDataBanHang] = useState({
    lstChiTiet: [],
  });

  useEffect(() => {
    loadChiTietDonHang();

    const escFunction = (event) => {
      if (event.key === "Escape") {
        CloseModalSua();
      }
    };

    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const convertDateSave = (date) => {
    if (!date) return null;

    const value = moment(date);

    if (!value.isValid() || value.year() <= 1901) {
      return null;
    }

    return value.format("YYYY-MM-DD HH:mm:ss");
  };

  const loadChiTietDonHang = () => {
    setLoading(true);

    DatHangApi.chiTietDonHang(item.OrderDatHangID)
      .then((response) => {
        setLoading(false);

        if (response.status === 200) {
          const data = response.data || {};

          setDataBanHang({
            ...data,
            OrderDatHangID: item.OrderDatHangID || data.OrderDatHangID,
            OrderCode: data.OrderCode,
            CreatedTime: data.CreatedTime,
            NgayDuKienGiao: data.NgayDuKienGiao,
            UpdatedTime: new Date(),
            CreatedUser: getUserLogin().UserName,
            UpdatedUser: getUserLogin().UserName,
            CustomerDebt: Number(data.CustomerDebt || 0) * -1,
            TongTienConNo:
              Number(data.TotalAmount || 0) +
              Number(data.OtherFee || 0) -
              Number(data.ChietKhau || 0) -
              Number(data.TotalPaid || 0) -
              Number(data.TongTienDaThanhToan || 0),
            isShowThueGTGT: data.IsLayHoaDon === true,
            lstChiTiet: data.lstChiTiet || [],
            lstLoaiPBCNQuaHan: [],
          });
        } else {
          pushNotification(response.data, "error", "TOP_RIGHT", 2000);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log("Lỗi lấy chi tiết đơn đặt hàng", err);
        pushNotification(
          "Lỗi lấy chi tiết đơn đặt hàng",
          "error",
          "TOP_RIGHT",
          2000,
        );
      });
  };

  const changeSoLuong = (index, value) => {
    const onlyNumber = value.toString().replace(/[^0-9.]/g, "");

    setDataBanHang((prev) => {
      const list = [...(prev.lstChiTiet || [])];

      list[index] = {
        ...list[index],
        ValueOfUnitForExportPrice: onlyNumber,
      };

      return {
        ...prev,
        lstChiTiet: list,
      };
    });
  };

  const saveBanHang = () => {
    const value = {
      ...dataBanHang,
      lstChiTiet: [...(dataBanHang.lstChiTiet || [])],
    };

    if (value.BranchID === 0) {
      pushNotification(
        "Chưa xác nhận được chi nhánh đặt hàng. Vui lòng chọn lại chi nhánh",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    if (value.CustomerID === 0) {
      pushNotification(
        "Chưa xác nhận được thông tin đại lý. Vui lòng tải lại trang",
        "error",
        "TOP_RIGHT",
        2000,
      );
      return;
    }

    if (!value.lstChiTiet || value.lstChiTiet.length === 0) {
      pushNotification("Chưa có sản phẩm nào", "error", "TOP_RIGHT", 2000);
      return;
    }

    for (let i = 0; i < value.lstChiTiet.length; i++) {
      const qty = Number(value.lstChiTiet[i].ValueOfUnitForExportPrice || 0);

      if (qty <= 0) {
        pushNotification(
          "Số lượng sản phẩm phải lớn hơn 0",
          "error",
          "TOP_RIGHT",
          2000,
        );
        return;
      }

      value.lstChiTiet[i] = {
        ...value.lstChiTiet[i],
        ValueOfUnitForExportPrice: qty,
        SaleTime: value.lstChiTiet[i].SaleTime
          ? convertDateSave(value.lstChiTiet[i].SaleTime)
          : convertDateSave(value.CreatedTime),
      };
    }

    value.CreatedTime = convertDateSave(value.CreatedTime);
    value.UpdatedTime = convertDateSave(new Date());
    value.HanThanhToan = convertDateSave(value.HanThanhToan);
    value.NgayDuKienGiao = convertDateSave(value.NgayDuKienGiao);

    if (value.IsLayHoaDon === true) {
      value.TotalAmount = value.TotalAmountNew;
    } else {
      value.TotalAmountNew = 0;
      value.TotalAmountThueGTGT = 0;
    }

    value.UpdatedUser = getUserLogin().UserName;
    value.sUserName = getUserLogin().UserName;
    value.ChietKhau_NhomSP = value.ChietKhau_NhomSP || 0;
    value.listChietKhauNhom = value.listChietKhauNhom || [];

    setDoubleClick(true);

    DatHangApi.addOrUpdateDatHang(value)
      .then((response) => {
        if (response.status === 200) {
          pushNotification(
            "Cập nhật đơn đặt hàng thành công",
            "success",
            "TOP_RIGHT",
            2000,
          );

          dispatch(getListDanhSachDonDatHang(dataSearch));
          CloseModalSua();
        } else {
          setDoubleClick(false);
          pushNotification(response.data, "error", "TOP_RIGHT", 4000);
        }
      })
      .catch((err) => {
        setDoubleClick(false);
        console.log("Lỗi cập nhật đơn đặt hàng", err);
        pushNotification(
          "Lỗi cập nhật đơn đặt hàng",
          "error",
          "TOP_RIGHT",
          4000,
        );
      });
  };

  return (
    <div className="popup">
      <div className="popup_inner" style={{ maxWidth: "720px" }}>
        <div className="modal-content form-modal-new">
          <div className="modal-header">
            <h4
              className="modal-title"
              style={{
                fontSize: "18px",
                fontWeight: "600",
                lineHeight: "24px",
              }}
            >
              <div className="bgIconTitle">
                <Icon path={mdiPencil} title="" color="#fff" size={1.3} />
              </div>
              Sửa số lượng đơn đặt hàng: {item.OrderCode}
            </h4>

            <button
              type="button"
              className="close"
              onClick={CloseModalSua}
              aria-label="Close"
            >
              <Icon path={mdiClose} title="Đóng" size={1.5} color="#ccc" />
            </button>
          </div>

          <div className="modal-body text-left-main">
            {loading ? (
              <div style={{ padding: "20px", textAlign: "center" }}>
                Đang tải dữ liệu...
              </div>
            ) : (
              <div className="giaodich-table-wrap">
                <table className="giaodich-table">
                  <thead>
                    <tr>
                      <th className="text-left">Tên sản phẩm</th>
                      <th className="text-right">Số lượng</th>
                    </tr>
                  </thead>

                  <tbody>
                    {dataBanHang.lstChiTiet &&
                    dataBanHang.lstChiTiet.length > 0 ? (
                      dataBanHang.lstChiTiet.map((row, index) => (
                        <tr key={row.OrderDatHangDetailsID || index}>
                          <td className="text-left">
                            {row.CategoryName || ""}
                          </td>

                          <td className="text-right">
                            <input
                              type="text"
                              className="form-control text-right"
                              value={row.ValueOfUnitForExportPrice || ""}
                              onChange={(e) =>
                                changeSoLuong(index, e.target.value)
                              }
                              style={{
                                maxWidth: "130px",
                                marginLeft: "auto",
                              }}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2" className="giaodich-empty">
                          Không có sản phẩm
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <div className="modal-footer">
            <div className="footer-search-main">
              <button
                type="button"
                className="text-button-search mr-2"
                onClick={CloseModalSua}
              >
                Huỷ bỏ
              </button>

              <button
                type="button"
                className="button-Add-NoIcon bg-blue-main"
                onClick={saveBanHang}
                disabled={doubleClick || loading}
              >
                Lưu lại
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
